<template>
  <div :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive"
    @drop.prevent="onDrop">
    <slot :dropZoneActive="active"></slot>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { defineEmits, onMounted, onUnmounted, ref } from 'vue'
const emit = defineEmits(['files-dropped'])

const active = ref(false)
const inActiveTimeout = ref(null)

const setActive = () => {
  active.value = true
  clearTimeout(inActiveTimeout.value)
}

const setInactive = () => {
  inActiveTimeout.value = setTimeout(() => {
    active.value = false
  }, 50)
}

const onDrop = (e) => {
  setInactive()
  emit('files-dropped', [...e.dataTransfer.files])
}

const preventDefaults = (e) => {
  e.preventDefault()
}

const events = ['dragenter', 'dragover', 'dragleave', 'drop']

onMounted(async () => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults)
  })
})

onUnmounted(async () => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults)
  })
})
</script>
